import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import WidgetApp from './WidgetApp';
import AdminApp from './AdminApp';
import ClientQuotePage from './ClientQuotePage';

const isAdminRoute = window.location.pathname.startsWith('/admin');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isAdminRoute ? <AdminApp /> : window.location.pathname === '/devis' ? <ClientQuotePage /> : <WidgetApp />}
  </React.StrictMode>
);
